export default "__VITE_ASSET__9XI6ySXx__"